/**
 * Gets the index of the given object in the store
 * @param dataStore The data store
 * @param object The object to compare with
 * @param compareProperties The properties used to find the object in the store
 */
export function getIndexInStore<T>(dataStore: T[], object: T, compareProperties: (keyof T)[]) {
	return dataStore.findIndex(obj => compareProperties.reduce((pv, cv) => pv && obj[cv] === object[cv], true));
}
